var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_680_1815",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 68,
    height: 68
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 68,
    height: 68,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_680_1815)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.281 70.5388C30.2831 68.5319 28.7229 66.2242 27.6004 63.6156C26.4779 61.007 25.9167 58.3102 25.9167 55.525C25.9167 52.7318 26.4517 49.9603 27.5218 47.2106C28.5913 44.4608 30.3194 41.8927 32.706 39.5061C34.4315 37.7806 36.592 36.3592 39.1873 35.2419C41.7826 34.1251 44.7222 33.2744 48.006 32.6898C51.2899 32.1047 54.8686 31.764 58.7423 31.6676C62.6164 31.5718 66.6803 31.6962 70.9341 32.0409C71.2391 36.102 71.3435 40.0479 71.2472 43.8786C71.1508 47.7088 70.8158 51.2802 70.2421 54.5928C69.6678 57.906 68.8296 60.8892 67.7275 63.5426C66.6248 66.1961 65.2053 68.3909 63.469 70.1273C61.1296 72.4851 58.6277 74.2061 55.9635 75.2903C53.2992 76.3746 50.6007 76.9167 47.8679 76.9167C45.003 76.9167 42.1883 76.3554 39.4239 75.233C36.6595 74.1105 34.2785 72.5458 32.281 70.5388ZM38.6341 70.0728C40.0578 70.9667 41.5626 71.6224 43.1483 72.0398C44.734 72.4577 46.3096 72.6667 47.875 72.6667C50.0595 72.6667 52.2202 72.2344 54.357 71.3697C56.4942 70.5051 58.5217 69.0957 60.4394 67.1417C61.2861 66.2917 62.1446 65.0993 63.0149 63.5646C63.8848 62.0299 64.6372 60.0229 65.2724 57.5438C65.9075 55.0646 66.3897 52.066 66.7188 48.5479C67.0479 45.0299 67.1126 40.8389 66.9129 35.975C64.599 35.8806 61.9808 35.8541 59.0582 35.8957C56.1361 35.9377 53.221 36.1757 50.3131 36.6097C47.4056 37.0437 44.6578 37.7239 42.0695 38.6504C39.4813 39.5764 37.3879 40.8387 35.7894 42.4371C33.6828 44.5442 32.219 46.6775 31.3978 48.8369C30.577 50.9964 30.1667 53.0442 30.1667 54.9803C30.1667 57.6573 30.6889 60.0784 31.7335 62.2436C32.7776 64.4082 33.8644 66.0154 34.994 67.0652C36.5778 63.5056 38.8036 60.0902 41.6714 56.8191C44.5392 53.5481 48.1727 50.6939 52.572 48.2568C49.2442 51.1591 46.3944 54.3466 44.0224 57.8193C41.6504 61.2916 39.8543 65.376 38.6341 70.0728Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEsg);
export default __webpack_public_path__ + "static/media/logo_ESG.e2d7ae81fdea691e69074d59e1f99736.svg";
export { ForwardRef as ReactComponent };